"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _defineProperty2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
require("vue-slider-component/theme/default.css");
var _vue2Editor = require("vue2-editor");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _hike = require("@/api/hike");
var _resource = require("@/api/resource");
var _game = require("@/api/game");
var _vuex = require("vuex");
var _lhJsCommonLib = require("@lifehikes/lh-js-common-lib");
var _hike720Report = require("@/api/hike720-report");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Tinymce from '@/components/Tinymce'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeStageActionSet',
  components: {
    VueEditor: _vue2Editor.VueEditor,
    UploadExcelComponent: _index.default
  },
  data: function data() {
    return {
      customToolbar: [['bold'], [{
        list: 'bullet'
      }], ['link']],
      rateTooltipFormatter: '{value}%',
      asIndex: 0,
      actionIndex: 0,
      dialogSkillVisible: false,
      dialogResourceVisible: false,
      dialogGameVisible: false,
      resourceQuery: {
        page: 1,
        limit: 999,
        q: undefined,
        sort: 'title'
      },
      resourceOptions: [],
      skillList: [],
      gameList: [],
      loading: false,
      firstTab: 'stage1',
      actionsetTab: 'actionset1',
      actionTab: 'setting',
      activeName: 'first',
      stageActionSetType: _lifehikesInitData.stageActionSetType,
      stageActionType: _lifehikesInitData.stageActionType,
      stageIndex: 0,
      hike: {},
      relatedLoops: [],
      relatedLoopsLoading: false,
      emptyActionSet: {
        type: '',
        title: '',
        actions: [],
        dialTestRate: 20
      },
      emptyAction: {
        type: '',
        title: '',
        // no use
        description: '',
        isSubscriptionIndividualCoachingMandatoryActivity: false,
        enableDialTest: false,
        // default is false
        enableP2pDialTest: false,
        p2pDialTestRaterCount: 1,
        p2pDialTestRaterMin: 1,
        p2pDialTestRaterMax: 5,
        minRecordingTime: 30,
        // in seconds
        maxRecordingTime: 120,
        // in seconds
        autoCutRecordingTime: 150,
        // in seconds
        stepsValue: 0,
        // after the action, gain steps
        timeInMinutes: 0,
        // in minutes
        recordingTexts: [],
        // For prompts during recording.
        scoreConfig: undefined
      },
      defaultScore: {
        rate: 30,
        scores: (0, _lhJsCommonLib.tagMapping)(_lifehikesInitData.skillCompassVideoDefault)
      },
      suggestWeightForEachVideo: 100,
      survey720ParticipantList: [],
      survey720ParticipantWithoutSurveyList: [],
      survey720RateError: "",
      survey720DataType: "",
      survey720Status: {},
      survey720TableTotalDataCount: 0,
      survey720TableValidDataCount: 0,
      survey720ScoreMapping: {},
      survey720TableData: {},
      survey720TableHeader: [],
      survey720DialogVisible: false,
      survey720DialogType: "",
      survey720SmallDrop: "smallDrop",
      scLibrary: (0, _lhJsCommonLib.tagMapping)(_lifehikesInitData.skillCompassLibrary)
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['email'])), {}, {
    isHikeAssociatedWithSubscription: function isHikeAssociatedWithSubscription() {
      if (Array.isArray(this.relatedLoops) && this.relatedLoops.length > 0) {
        return this.relatedLoops.some(function (loop) {
          return loop && loop.metadata && loop.metadata.subscriptionId;
        });
      }
      return false;
    }
  }),
  /*
  watch: {
    hikeStages: {
      handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal)
      },
      deep: true
    }
  },
  */
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.firstTab = typeof _this.$route.query.s === 'undefined' ? 'stage1' : _this.$route.query.s;
            _context.n = 1;
            return _this.getHike();
          case 1:
            _context.n = 2;
            return _this.getHikeSkillList();
          case 2:
            _context.n = 3;
            return _this.getHikeGameList();
          case 3:
            _this.getResources();
            _this.getHikeGameList();
            _this.getHikeParticipants();
            _this.getSurvey720Status();
            _this.getRelatedLoops();
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    dateFormatter: function dateFormatter(dateStr) {
      var theDate = (0, _momentTimezone.default)(String(dateStr));
      if (theDate.isValid()) {
        return theDate.format("YYYY-MM-DD HH:mm:ss");
      }
      return "--";
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/edit/".concat(id));
    },
    moveNext: function moveNext(stageIndex, actionsetIndex) {
      if (actionsetIndex < this.hike.stages[stageIndex].actionSets.length) {
        var element = this.hike.stages[stageIndex].actionSets[actionsetIndex];
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex, this.hike.stages[stageIndex].actionSets[actionsetIndex + 1]);
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex + 1, element);
        // console.log(this.hikeStages);
      }
    },
    resetScore: function resetScore(stageIdx, actionsetIdx, actionIdx) {
      var scoreConfig = this.hike.stages[stageIdx].actionSets[actionsetIdx].actions[actionIdx].scoreConfig;
      var oldConfig = _lodash.default.cloneDeep(scoreConfig);
      var newConfig = _lodash.default.cloneDeep(this.defaultScore);
      newConfig['scores'].forEach(function (item) {
        var oldValue = oldConfig['scores'].find(function (oldItem) {
          return oldItem['key'] === item['key'];
        });
        if (oldValue) {
          item['rate'] = oldValue['rate'];
          item['weight'] = oldValue['rate'];
          item['enable'] = oldValue['enable'];
        }
      });
      this.hike.stages[stageIdx].actionSets[actionsetIdx].actions[actionIdx].scoreConfig = newConfig;
    },
    movePrevious: function movePrevious(stageIndex, actionsetIndex) {
      if (actionsetIndex > 0) {
        var element = this.hike.stages[stageIndex].actionSets[actionsetIndex];
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex, this.hike.stages[stageIndex].actionSets[actionsetIndex - 1]);
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex - 1, element);
        // console.log(this.hikeStages);
      }
    },
    save: function save() {
      var _this2 = this;
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      var stageActionSetTypes = {};
      stageActionSetTypes['stage'] = ['bunny', 'diamond', 'info', 'moment', 'bonus'];
      stageActionSetTypes['benchmark'] = ['bunny', 'diamond', 'moment', 'benchmark', 'benchmarkreport', 'bonus'];
      stageActionSetTypes['summit'] = ['summit', 'moment', 'summitreport'];
      var stages = this.hike.stages;
      for (var stageIndex in stages) {
        var benchmarkType = 0;
        var benchmarkReportType = 0;
        var summitType = 0;
        var summitReportType = 0;
        var componentType = 0;
        for (var actionSetIdnex in stages[stageIndex].actionSets) {
          if (stages[stageIndex].actionSets[actionSetIdnex].type === undefined || stages[stageIndex].actionSets[actionSetIdnex].type === '') {
            (0, _log.displayPopupMessage)('Type is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity.', 'error');
            return;
          }
          for (var actionIndex in stages[stageIndex].actionSets[actionSetIdnex].actions) {
            var actionType = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].type;
            if (actionType === undefined || actionType === '') {
              (0, _log.displayPopupMessage)('Type is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            if (actionType === "dialtestexercise") {
              componentType++;
            }
            var actionTitle = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].title;
            if (actionTitle === undefined || actionTitle === '') {
              (0, _log.displayPopupMessage)('Title is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            var enableP2pDialTest = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].enableP2pDialTest;
            if (enableP2pDialTest) {
              var p2pDialTestRaterMax = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].p2pDialTestRaterMax;
              var p2pDialTestRaterMin = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].p2pDialTestRaterMin;
              if (p2pDialTestRaterMax < p2pDialTestRaterMin) {
                (0, _log.displayPopupMessage)('P2P Dial Testing maximum value must be larger or equal than the minimum value in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease modify it before saving activity.', 'error');
                return;
              }
            }
            if (actionType === 'skill') {
              var skillId = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].skill;
              if (skillId === undefined || skillId === null || skillId === '') {
                (0, _log.displayPopupMessage)('Skill Id is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
                return;
              }
            }
            if (actionType === 'resource') {
              var resource = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource;
              if (resource === undefined || resource === null) {
                (0, _log.displayPopupMessage)('Resource Id is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
                return;
              }
            }
            if (actionType === 'game') {
              var game = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].game;
              if (game === undefined || game === null) {
                (0, _log.displayPopupMessage)('Game Id is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
                return;
              }
            }
            var scoreConfig = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].scoreConfig;
            if (scoreConfig !== undefined && scoreConfig['scores'] !== undefined && Array.isArray(scoreConfig['scores'])) {
              scoreConfig['scores'].forEach(function (item) {
                if (item['rate'] !== undefined) {
                  item['weight'] = item['rate'];
                }
              });
            }
            var actionDescription = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].description;
            if (actionDescription && actionDescription !== '') {
              var divForDescription = document.createElement('div');
              divForDescription.innerHTML = actionDescription;
              var links = divForDescription.getElementsByTagName('a');
              var _iterator = (0, _createForOfIteratorHelper2.default)(links),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var link = _step.value;
                  var hrefs = link.outerHTML.match(/href="([^"]*)/g);
                  var href = hrefs[hrefs.length - 1].substring(6);
                  if (!this.isValidHttpUrl(href)) {
                    (0, _log.displayPopupMessage)('Please check link ' + link.outerText + ' in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + ' description.', 'error');
                    return;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }
          var actionSet = stages[stageIndex].actionSets[actionSetIdnex];
          var actionSetTypes = stageActionSetTypes[stages[stageIndex].type];
          var type = actionSet.type;
          if (type === 'benchmark') {
            var raterCount = actionSet.raterCount;
            var raterTaskCredit = actionSet.raterTaskCredit;
            if (raterTaskCredit === undefined) {
              (0, _log.displayPopupMessage)('Task Credit is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            if (raterCount === undefined) {
              (0, _log.displayPopupMessage)('RaterCount is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity. (Suggest to set it as 1.)', 'error');
              return;
            }
            benchmarkType++;
          } else if (type === 'benchmarkreport') {
            benchmarkReportType++;
          } else if (type === 'summit') {
            var _raterCount = actionSet.raterCount;
            var _raterTaskCredit = actionSet.raterTaskCredit;
            if (_raterTaskCredit === undefined) {
              (0, _log.displayPopupMessage)('Task Credit is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            if (_raterCount === undefined) {
              (0, _log.displayPopupMessage)('RaterCount is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity. (Suggest to set it as 2.)', 'error');
              return;
            }
            summitType++;
          } else if (type === 'summitreport') {
            summitReportType++;
          }
          if (!actionSetTypes.includes(actionSet.type)) {
            var msg = 'Stage ' + (1 * stageIndex + 1) + ':[' + stages[stageIndex].type + '] should not include activity: [' + actionSet.type + '].';
            (0, _log.displayPopupMessage)(msg, 'error');
            return;
          }
        }
        var errType = '';
        if (benchmarkType > 1) {
          errType = 'benchmark';
        } else if (benchmarkReportType > 1) {
          errType = 'benchmarkreport';
        } else if (summitType > 1) {
          errType = 'summit';
        } else if (summitReportType > 1) {
          errType = 'summitreport';
        }
        if (errType !== '') {
          (0, _log.displayPopupMessage)('Activity type [' + errType + '] should not more than 1. \nPlease remove it before saving activity.', 'error');
          return;
        }
        if (componentType > 1) {
          (0, _log.displayPopupMessage)("Within a stage, Component type 'dialtestexercise'  should not more than 1.\n It's in Stage " + (1 * stageIndex + 1) + ".\n Please remove it before saving activity.", 'error');
          return;
        }
      }
      this.loading = true;
      (0, _hike.updateHikeById)(token, id, {
        stages: stages
      }).then(function (response) {
        _this2.hike = response.data;
        for (var i = 0; i < _this2.checkArrayLength(_this2.hike.stages); i++) {
          for (var j = 0; j < _this2.checkArrayLength(_this2.hike.stages[i].actionSets); j++) {
            for (var k = 0; k < _this2.checkArrayLength(_this2.hike.stages[i].actionSets[j].actions); k++) {
              if (_this2.hike.stages[i].actionSets[j].actions[k].type === 'resource') {
                var resId = _this2.hike.stages[i].actionSets[j].actions[k].resource ? _this2.hike.stages[i].actionSets[j].actions[k].resource.id : null;
                console.info('resource id:' + resId);
                _this2.hike.stages[i].actionSets[j].actions[k].resource = resId;
              }
            }
          }
        }
        _this2.loading = false;
        var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is updated.");
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(_this2, 'Hike', "".concat(_lifehikesInitData.userEvent.hike.edit), oEmail, "Edit in Action Setting - Hike Id: ".concat(id));
        (0, _ga.writeGaEvent)(_this2, 'Hike', "".concat(_lifehikesInitData.userEvent.hike.edit), _this2.email, "avoid undefined email, Edit in Action Setting - Hike Id: ".concat(id));
        var keys_to_keep = ['role', 'user'];
        var result = _this2.hike.staff.map(function (e) {
          var obj = {};
          keys_to_keep.forEach(function (k) {
            return obj[k] = e[k];
          });
          return obj;
        });
        (0, _ga.writeGaEvent)(_this2, 'Hike', "".concat(_lifehikesInitData.userEvent.hike.edit), oEmail, "Staff: ".concat(JSON.stringify(result)));
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-updateHikeById-error', error);
        _this2.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    isValidHttpUrl: function isValidHttpUrl(string) {
      var url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === 'http:' || url.protocol === 'https:';
    },
    getHike: function getHike() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var id, token;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              id = typeof _this3.$route.params.id === 'undefined' ? '' : _this3.$route.params.id;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this3.loading = true;
              _context2.n = 1;
              return (0, _hike.getHikeById)(token, id).then(function (response) {
                _this3.hike = response.data;
                var overallTotal = 0;
                if (_this3.hike.skillCompassDimensions === 'auto') {
                  if (_this3.hike.report && _this3.hike.report.scoreConfig && _this3.hike.report.scoreConfig.overall) {
                    var _iterator2 = (0, _createForOfIteratorHelper2.default)(_this3.hike.report.scoreConfig.overall),
                      _step2;
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var skill = _step2.value;
                        overallTotal += skill.weight;
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                }
                _this3.suggestWeightForEachVideo = 100 - overallTotal;
                //fixed bug LHVO-4485
                if (_this3.hike.report) {
                  if (_this3.hike.report.scoreConfig) {
                    _this3.defaultScore.scores = _this3.hike.report.scoreConfig.video;
                  }
                }
                for (var i = 0; i < _this3.checkArrayLength(_this3.hike.stages); i++) {
                  for (var j = 0; j < _this3.checkArrayLength(_this3.hike.stages[i].actionSets); j++) {
                    for (var k = 0; k < _this3.checkArrayLength(_this3.hike.stages[i].actionSets[j].actions); k++) {
                      if (_this3.hike.stages[i].actionSets[j].actions[k].isSubscriptionIndividualCoachingMandatoryActivity === undefined) {
                        _this3.$set(_this3.hike.stages[i].actionSets[j].actions[k], 'isSubscriptionIndividualCoachingMandatoryActivity', false);
                      }
                      if (_this3.hike.stages[i].actionSets[j].actions[k].type === 'resource') {
                        var resId = _this3.hike.stages[i].actionSets[j].actions[k].resource ? _this3.hike.stages[i].actionSets[j].actions[k].resource.id : null;
                        _this3.hike.stages[i].actionSets[j].actions[k].resource = resId;
                      }
                    }
                  }
                }
                _this3.loading = false;
              }).catch(function (error) {
                (0, _log.showDebugLog)('hike-getHikeById-error', error);
                _this3.loading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    addActionSet: function addActionSet(idx) {
      var actionSetLength = this.hike.stages[idx].actionSets.length;
      var actionSet = _lodash.default.cloneDeep(this.emptyActionSet);
      this.hike.stages[idx].actionSets.push(actionSet);
      this.actionsetTab = "actionset".concat(actionSetLength + 1);
    },
    canAddActionSet: function canAddActionSet(stage) {
      /*
      if (stage.type === 'benchmark' || stage.type === 'summit'){
        if (stage.actionSets.length >=1)
          return false
        else return true
      }
      else {
        return true
      }
      */
      return true;
    },
    selectAction: function selectAction(e, stageIdx, actionSetIdx) {
      var action = null;
      var actionLength = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.length;
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.splice(0, actionLength);
      if (e === 'benchmark' || e === 'summit') {
        // Only add first video
        action = _lodash.default.cloneDeep(this.emptyAction);
        action.scoreConfig = _lodash.default.cloneDeep(this.defaultScore);
        action.type = 'video';
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.push(action);
      } else {
        action = _lodash.default.cloneDeep(this.emptyAction);
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.push(action);
      }
    },
    canAddAction: function canAddAction(actionSetType, actions) {
      if (actionSetType === 'bunny' || actionSetType === 'diamond' || actionSetType === 'moment' || actionSetType === 'info' || actionSetType === 'summitreport' || actionSetType === 'benchmarkreport') {
        // bunny / diamond / moment
        if (actions.length >= 1) {
          return false;
        } else {
          return true;
        }
      } else if (actionSetType === 'benchmark' || actionSetType === 'summit') {
        if (actions.length >= 9) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    addAction: function addAction(stageIdx, actionSetIdx) {
      var action = _lodash.default.cloneDeep(this.emptyAction);
      action.scoreConfig = _lodash.default.cloneDeep(this.defaultScore);
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.push(action);
      // console.log('empty action', this.hike.stages[stageIdx].actionSets[actionSetIdx].actions)
    },
    addRecordingText: function addRecordingText(stageIdx, actionSetIdx, actionIdx) {
      var text = {
        interval: 1,
        text: ''
      };
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].recordingTexts.push(text);
    },
    checkScoreExist: function checkScoreExist(action, actionSet) {
      var ret = false;
      if ((actionSet.type === 'benchmark' || actionSet.type === 'summit') && action.type === 'video') {
        ret = true;
        if (action.scoreConfig === undefined) {
          action.scoreConfig = _lodash.default.cloneDeep(this.defaultScore);
        }
      } else {
        ret = false;
      }
      // console.log(action)
      return ret;
    },
    removeActionSet: function removeActionSet(stageIdx, actionSetIdx) {
      this.hike.stages[stageIdx].actionSets.splice(actionSetIdx, 1);
      this.actionsetTab = actionSetIdx === 0 ? "actionset1" : "actionset".concat(actionSetIdx);
    },
    removeAction: function removeAction(stageIdx, actionSetIdx, actionIdx) {
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.splice(actionIdx, 1);
    },
    moveUp: function moveUp(stageIdx, actionSetIdx, actionIdx) {
      var actions = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions;
      var currentAction = actions[actionIdx];
      this.$set(actions, actionIdx, actions[actionIdx - 1]);
      this.$set(actions, actionIdx - 1, currentAction);
    },
    moveDown: function moveDown(stageIdx, actionSetIdx, actionIdx) {
      var actions = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions;
      var currentAction = actions[actionIdx];
      this.$set(actions, actionIdx, actions[actionIdx + 1]);
      this.$set(actions, actionIdx + 1, currentAction);
    },
    getActionSetVideoTotalLength: function getActionSetVideoTotalLength(actionSet) {
      var totalMinSec = 0;
      var totalMaxSec = 0;
      var totalDt = 0;
      if (actionSet['actions'] !== undefined) {
        for (var i = 0; i < actionSet.actions.length; i++) {
          totalMaxSec += actionSet.actions[i].maxRecordingTime;
          totalMinSec += actionSet.actions[i].minRecordingTime;
          if (actionSet.actions[i].enableDialTest === true) {
            totalDt++;
          }
        }
      }
      return '[' + actionSet.actions.length + '] video. [' + totalDt + '] DialTest. [' + totalMinSec + 's] min recording time. [' + totalMaxSec + 's] Ideal recording time.';
    },
    getActionSetType: function getActionSetType(stageType) {
      var actionSetType = [];
      if (stageType === 'benchmark') {
        // actionSetType = ['benchmark', 'bunny', 'diamond', 'benchmarkreport']
        actionSetType = ['benchmark', 'bunny', 'diamond', 'moment', 'benchmarkreport', 'bonus'];
      } else if (stageType === 'summit') {
        // actionSetType = ['summit', 'bunny', 'diamond', 'info', 'summitreport']
        actionSetType = ['summit', 'moment', 'summitreport'];
      } else if (stageType === 'stage') {
        actionSetType = ['bunny', 'diamond', 'moment', 'info', 'bonus'];
        // for future use
        // actionSetType = ['bunny', 'diamond', 'moment',  'info', 'resource']
      } else {
        actionSetType = [];
      }
      return actionSetType;
    },
    getActionType: function getActionType(actionSetType, stageType) {
      console.log('At getActionType', actionSetType, stageType);
      var actionType = [];
      if (actionSetType === 'benchmark' || actionSetType === 'summit') {
        actionType = ['video'];
      } else if (actionSetType === 'moment') {
        // LHVO-4124 Benchmark or Summit stage only allow dial test exercise under moment
        if (stageType == 'benchmark' || stageType == 'summit') {
          actionType = ['dialtestexercise'];
        } else {
          actionType = ['video', 'resource', 'dialtestexercise'];
        }
      } else if (actionSetType === 'bunny' || actionSetType === 'diamond' || actionSetType === 'bonus') {
        actionType = ['video', 'info', 'skill', 'resource', 'game']; // Next time should add 'skill'
      } else if (actionSetType === 'benchmarkreport') {
        actionType = ['benchmarkreport'];
      } else if (actionSetType === 'summitreport') {
        actionType = ['summitreport'];
      } else if (actionSetType === 'info') {
        actionType = ['info'];
      } else if (actionSetType === 'resource') {
        actionType = ['resource'];
      } else if (actionSetType === 'skill') {
        actionType = ['skill'];
      } else if (actionSetType === 'game') {
        actionType = ['game'];
      } else {
        actionType = [];
      }
      return actionType;
    },
    calcSkillFactors: function calcSkillFactors(actionScoreSetting) {
      var total = 0;
      for (var i = 0; i < actionScoreSetting.length; i++) {
        if (typeof actionScoreSetting[i].rate !== 'undefined') {
          if (typeof actionScoreSetting[i].enable !== 'undefined' && actionScoreSetting[i].enable) {
            total += actionScoreSetting[i].rate;
          }
        }
      }
      return total.toFixed(2);
    },
    calcSkillCount: function calcSkillCount(actionScoreSetting) {
      var total = 0;
      for (var i = 0; i < actionScoreSetting.length; i++) {
        if (typeof actionScoreSetting[i].rate !== 'undefined') {
          if (typeof actionScoreSetting[i].enable !== 'undefined' && actionScoreSetting[i].enable) {
            total++;
          }
        }
      }
      return total;
    },
    calcVideoScore: function calcVideoScore(actionSet) {
      var total = 0;
      // console.log('showVideoScoreAlert', actionSet)
      if (typeof actionSet.actions !== 'undefined') {
        for (var i = 0; i < actionSet.actions.length; i++) {
          // console.log(`scor3e-${i}`, actionScoreConfig[i].scoreConfig)
          if (typeof actionSet.actions[i].scoreConfig !== 'undefined') {
            total += actionSet.actions[i].scoreConfig.rate;
          }
        }
      }
      return total;
    },
    calcVideoCount: function calcVideoCount(actionSet) {
      if (typeof actionSet.actions !== 'undefined') {
        return actionSet.actions.length;
      }
      return 0;
    },
    getHikeSkillList: function getHikeSkillList() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var token;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _context3.n = 1;
              return (0, _hike.getSkillList)(token).then(function (response) {
                _this4.skillList = response.data.rows;
              }).catch(function (error) {
                (0, _log.showDebugLog)('hike-skillList-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getHikeGameList: function getHikeGameList() {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var token;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _context4.n = 1;
              return (0, _game.getGameForHike)(token).then(function (response) {
                _this5.gameList = response.data.rows;
              }).catch(function (error) {
                (0, _log.showDebugLog)('hike-gameList-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    stageTabClick: function stageTabClick() {
      this.actionsetTab = 'actionset1';
    },
    openSkillDialog: function openSkillDialog(actionIndex, asIndex, stageIndex) {
      this.dialogSkillVisible = true;
      this.stageIndex = stageIndex;
      this.asIndex = asIndex;
      this.actionIndex = actionIndex;
    },
    addSkillInAction: function addSkillInAction(skillId, skillTitle) {
      this.hike.stages[this.stageIndex].actionSets[this.asIndex].actions[this.actionIndex].skill = skillId;
      this.dialogSkillVisible = false;
    },
    clearSkill: function clearSkill(actionIndex, asIndex, stageIndex) {
      this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex].skill = undefined;
      // console.log('clear skill', this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex])
      // this.dialogSkillVisible = false
      this.$forceUpdate();
    },
    openGameDialog: function openGameDialog(actionIndex, asIndex, stageIndex) {
      this.dialogGameVisible = true;
      this.stageIndex = stageIndex;
      this.asIndex = asIndex;
      this.actionIndex = actionIndex;
    },
    clearGame: function clearGame(actionIndex, asIndex, stageIndex) {
      this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex].game = undefined;
      // console.log('clear skill', this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex])
      // this.dialogSkillVisible = false
      this.$forceUpdate();
    },
    addGameInAction: function addGameInAction(gameId, GameTitle) {
      this.hike.stages[this.stageIndex].actionSets[this.asIndex].actions[this.actionIndex].game = gameId;
      this.dialogGameVisible = false;
    },
    getResources: function getResources() {
      var _this6 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _resource.fetchList)(token, this.resourceQuery).then(function (response) {
        var data = response.data;
        (0, _log.showDebugLog)('Resource-API-response', response.data);
        _this6.resourceOptions = data.rows;
        _this6.resourceTableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('Resource-API-response', error);
        _this6.resourceTableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    openResourceDialog: function openResourceDialog(actionIndex, asIndex, stageIndex) {
      this.dialogResourceVisible = true;
      this.stageIndex = stageIndex;
      this.asIndex = asIndex;
      this.actionIndex = actionIndex;
    },
    addResourceInAction: function addResourceInAction(resId, resTitle) {
      this.hike.stages[this.stageIndex].actionSets[this.asIndex].actions[this.actionIndex].resource = resId;
      this.dialogResourceVisible = false;
    },
    clearResource: function clearResource(actionIndex, asIndex, stageIndex) {
      this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex].resource = undefined;
      // console.log('clear resource', this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex])
      // this.dialogSkillVisible = false
      this.$forceUpdate();
    },
    checkArrayLength: function checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    },
    changeComponentType: function changeComponentType(event, actionIdx, actionSetIdx, stageIdx) {
      if (this.hike.stages && this.hike.stages[stageIdx].actionSets && this.hike.stages[stageIdx].actionSets[actionSetIdx].actions && this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx]) {
        var action = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx];
        if (event !== 'video' && event !== 'resource') {
          action.isSubscriptionIndividualCoachingMandatoryActivity = false;
        }
        if (action.resource) {
          delete action.resource;
        }
      } else {
        console.log('object not exist');
      }
    },
    config720SurveyRateChange: function config720SurveyRateChange(s) {
      if (!s.enable720Survey) {
        this.survey720RateError = "";
        return;
      }
      var bossRate = s.config720Survey.bossRate ? s.config720Survey.bossRate : 0;
      var directRate = s.config720Survey.directRate ? s.config720Survey.directRate : 0;
      var peerRate = s.config720Survey.peerRate ? s.config720Survey.peerRate : 0;
      var raterRate = s.config720Survey.raterRate ? s.config720Survey.raterRate : 0;
      if (bossRate + directRate + peerRate + raterRate === 100) {
        this.survey720RateError = "";
      } else {
        this.survey720RateError = "Final Score: Total rate should be 100%";
      }
    },
    getSurvey720Status: function getSurvey720Status() {
      var _this7 = this;
      this.survey720Status = {};
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var stage = this.getCurrentStage();
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      if (stage !== undefined) {
        if (stage.type === "benchmark" || stage.type === "summit") {
          (0, _hike720Report.getSurvey720Result)(token, id, stage.id).then(function (response) {
            _this7.survey720Status = response.data;
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    inputSurveyResult: function inputSurveyResult(type, stage) {
      this.survey720DataType = type;
      if (type === "peer") {
        this.survey720DialogType = "Peers";
      } else if (type === "boss") {
        this.survey720DialogType = "Boss";
      } else if (type === "directreport") {
        this.survey720DialogType = "Direct Report";
      }
      this.survey720TableTotalDataCount = 0;
      this.survey720TableData = {};
      this.survey720ScoreMapping = {};
      this.survey720TableHeader = [];
      this.survey720ParticipantWithoutSurveyList = [];
      this.survey720DialogVisible = true;
    },
    survey720EmailCheck: function survey720EmailCheck(email) {
      var checkResult = "";
      var foundEmail = false;
      var uuid = "";
      var _iterator3 = (0, _createForOfIteratorHelper2.default)(this.survey720ParticipantList),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var p = _step3.value;
          if (email === _lodash.default.trim(p["email"]).toLowerCase()) {
            foundEmail = true;
            uuid = p["uuid"];
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (!foundEmail) {
        checkResult = "SKIPPED: This person is not in the participant list";
      }
      return {
        result: checkResult,
        uuid: uuid
      };
    },
    survey720DataHandleSuccess: function survey720DataHandleSuccess(_ref) {
      var results = _ref.results,
        header = _ref.header;
      this.survey720TableHeader = header;
      this.survey720TableData = {};
      this.survey720ScoreMapping = {};
      this.survey720ParticipantWithoutSurveyList = [];
      this.survey720TableValidDataCount = 0;
      this.survey720TableTotalDataCount = results.length;
      var _iterator4 = (0, _createForOfIteratorHelper2.default)(results),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var r = _step4.value;
          var participantEmail = "";
          var scoreTotal = 0;
          var scoreCount = 0;
          for (var _i = 0, _Object$keys = Object.keys(r); _i < _Object$keys.length; _i++) {
            var questionTitle = _Object$keys[_i];
            // Check if the question is number type.
            var theTitle = questionTitle.replace(/\u00a0/g, " ").toLowerCase();
            if (theTitle.includes("(select 1 to 10")) {
              scoreCount++;
              scoreTotal += parseFloat(_lodash.default.trim(r[questionTitle]));
            } else if (theTitle.includes("lifehikes id")) {
              participantEmail = _lodash.default.trim(r[questionTitle].toLowerCase());
            }
          }
          var checkResult = this.survey720EmailCheck(participantEmail);
          var avgScoreFloat = 0;
          if (scoreCount > 0) {
            avgScoreFloat = scoreTotal / scoreCount;
          }
          var participant = {
            email: participantEmail,
            uuid: checkResult["uuid"],
            checkResult: checkResult["result"]
          };
          if (checkResult["result"] === "") {
            this.survey720TableValidDataCount++;
          }
          if (Object.keys(this.survey720ScoreMapping).includes(participantEmail)) {
            this.survey720ScoreMapping[participantEmail] += avgScoreFloat;
          } else {
            this.survey720ScoreMapping[participantEmail] = avgScoreFloat;
          }
          if (Object.keys(this.survey720TableData).includes(participantEmail)) {
            this.survey720TableData[participantEmail]["reports"].push(r);
            this.survey720TableData[participantEmail]["averageScore"] = this.survey720ScoreMapping[participantEmail] / this.survey720TableData[participantEmail]["reports"].length;
          } else {
            this.survey720TableData[participantEmail] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, participant), {}, {
              reports: [r]
            });
            this.survey720TableData[participantEmail]["averageScore"] = this.survey720ScoreMapping[participantEmail];
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var _iterator5 = (0, _createForOfIteratorHelper2.default)(this.survey720ParticipantList),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var p = _step5.value;
          var email = p["email"];
          if (!Object.keys(this.survey720TableData).includes(email)) {
            this.survey720ParticipantWithoutSurveyList.push(p);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    },
    survey720DataBeforeUpload: function survey720DataBeforeUpload(file) {
      return true;
    },
    survey720DataUpload: function survey720DataUpload() {
      var _this8 = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var stage = this.getCurrentStage();
      if (stage !== undefined) {
        (0, _hike720Report.updateSurvey720Result)(token, id, stage.id, this.survey720DataType, this.survey720TableData).then(function (response) {
          _this8.loading = false;
          _this8.getSurvey720Status();
          (0, _log.displayPopupMessage)("Survey720 Excel updated", "success");
          _this8.survey720DialogVisible = false;
        }).catch(function (error) {
          _this8.loading = false;
          (0, _log.showDebugLog)("Hike-updateSurvey720Result-API-error", error);
          (0, _log.displayPopupMessage)(error, "error");
        });
      } else {
        (0, _log.showDebugLog)("Hike-updateSurvey720Result-stage-empty-error", "Please save Hike stage content before upload the Excel");
        (0, _log.displayPopupMessage)("Please save Hike stage content before upload the Excel", "error");
      }
    },
    getHikeParticipants: function getHikeParticipants() {
      var _this9 = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      (0, _hike.getParticipant)(token, id).then(function (response) {
        _this9.loading = false;
        _this9.survey720ParticipantList = response.data.rows;
      }).catch(function (error) {
        _this9.loading = false;
        (0, _log.showDebugLog)("Hike-getParticipant-API-error", error);
        (0, _log.displayPopupMessage)(error, "error");
      });
    }
  }, "getSurvey720Status", function getSurvey720Status() {
    var _this0 = this;
    this.survey720Status = {};
    var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
    var stage = this.getCurrentStage();
    if (stage !== undefined) {
      if (stage.type === "benchmark" || stage.type === "summit") {
        (0, _hike720Report.getSurvey720Result)(token, id, stage.id).then(function (response) {
          _this0.survey720Status = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }), "getCurrentStage", function getCurrentStage() {
    var stageIdx = parseInt(this.firstTab.replace("stage", "")) - 1;
    if (stageIdx < this.hike.stages.length) {
      var stage = this.hike.stages[stageIdx];
      return stage;
    }
    return undefined;
  }), "skillShowNewKey", function skillShowNewKey(key) {
    var skill = this.scLibrary.find(function (p) {
      return p.key === key;
    });
    if (skill) {
      return skill.newKey ? skill.newKey : skill.key;
    } else {
      return key;
    }
  }), "p2pDialTestChange", function p2pDialTestChange(enableP2pDialTest, stageIdx, actionSetIdx, actionIdx) {
    //console.info(enableP2pDialTest)
    if (enableP2pDialTest) {
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMin = 1;
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMax = 5;
    } else {
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMin = null;
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMax = null;
    }
  }), "getRelatedLoops", function getRelatedLoops() {
    var _this1 = this;
    var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
    if (!id || !token) return;
    this.relatedLoopsLoading = true;
    (0, _hike.hikeRelatedLoops)(token, id).then(function (response) {
      _this1.relatedLoops = response && response.data && response.data.rows ? response.data.rows : [];
    }).catch(function (error) {
      (0, _log.showDebugLog)('hike-hikeRelatedLoops-error', error);
      _this1.relatedLoops = [];
    }).finally(function () {
      _this1.relatedLoopsLoading = false;
    });
  })
};